const getCurrentDate = () => {
  const date = new Date();
  return `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
};

const formatJobTitleForFileName = (jobTitle: string) => {
  const formattedTitle = jobTitle.toLowerCase();
  return formattedTitle.replace(/ /g, '-');
};

const buildCsvFilename = (jobTitle: string) =>
  `${formatJobTitleForFileName(
    jobTitle ? `${jobTitle}-` : '',
  )}candidates-${getCurrentDate()}.csv`;

export default buildCsvFilename;
